export const _path = {
    ROOTMAIN: '/app'
}

const menu = [{
    layout: 'app',
    title: 'Apartados',
    url: `${_path.ROOTMAIN}/pre-ventas`,
    // submenu: {
    //     type: 'menu',
    //     menu: [
    //         { title: 'Cotizaciones', url: `${_path.ROOTMAIN}/cotizaciones` },
    //         { title: 'Preventas', url: `${_path.ROOTMAIN}/pre-ventas` },
    //     ],
    // },
}, {
    layout: 'app',
    title: 'Facturacion',
    url: `${_path.ROOTMAIN}/facturas`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Facturas', url: `${_path.ROOTMAIN}/facturas` },
            // { title: 'Actualizar Facturas', url: `${_path.ROOTMAIN}/facturas-updates` },            
            { title: 'Gestión de caja', url: `${_path.ROOTMAIN}/cierres-caja` },
            { title: 'Recibos', url: `${_path.ROOTMAIN}/recibos` },
            { title: 'Nota de Crédito', url: `${_path.ROOTMAIN}/notascreditos` },
            {
                title: 'Reportes',
                url: ``,
                submenu: [
                    { title: 'Ventas', url: `${_path.ROOTMAIN}/facturas/reportes/ventas` },
                    { title: 'Recibos', url: `${_path.ROOTMAIN}/facturas/reportes/recibos` },
                    // { title: 'Comisiones', url: `${_path.ROOTMAIN}/facturas/reportes/comisiones` },
                    { title: 'Dashboard', url: `${_path.ROOTMAIN}/facturas/reportes/dashboard`, icon: 'dashboard.png' },
                ]
            },
        ],
    },
}, {
    layout: 'app',
    title: 'Inventario',
    url: `${_path.ROOTMAIN}/productos`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Productos', url: `${_path.ROOTMAIN}/productos` },
            { title: 'Colores', url: `${_path.ROOTMAIN}/color` },
            { title: 'Tallas', url: `${_path.ROOTMAIN}/tallas` },
            { title: 'Categorias', url: `${_path.ROOTMAIN}/categorias` },
            { title: 'Unidad Medida', url: `${_path.ROOTMAIN}/unidadmedida` },
            // { title: 'Conversiones', url: `${_path.ROOTMAIN}/productos/conversiones` },          
            // { title: 'Tasa de cambio', url: `${_path.ROOTMAIN}/tasa-de-cambio` },
            // { title: 'Existencias por fecha', url: `${_path.ROOTMAIN}/inventario/reportes/existencias-fecha` },
            {
                title: 'Reportes',
                url: ``,
                submenu: [
                    { title: 'Kardex', url: `${_path.ROOTMAIN}/inventario/reportes/kardex` },
                    { title: 'Existencias', url: `${_path.ROOTMAIN}/inventario/reportes/existencias` },
                    { title: 'Costos/Precios', url: `${_path.ROOTMAIN}/inventario/reportes/stock` },
                    // { title: 'Ult ingresos', url: `${_path.ROOTMAIN}/inventario/reportes/ingresos` },
                    // { title: 'Items mas vendidos', url: `${_path.ROOTMAIN}/inventario/reportes/mov-productos` },
                ]
            }
        ],
    }
}, {
    layout: 'app',
    title: 'Clientes',
    url: `${_path.ROOTMAIN}/clientes`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Gestión de clientes', url: `${_path.ROOTMAIN}/clientes` },
            { title: 'Cuentas por cobrar', url: `${_path.ROOTMAIN}/clientes/pending` },
            { title: 'Estado de cuenta Mora', url: `${_path.ROOTMAIN}/clientes/mora` },
            { title: 'Historial Pagos', url: `${_path.ROOTMAIN}/clientes/historial` },
        ],
    },
}, {
    layout: 'app',
    title: 'Compras',
    url: `${_path.ROOTMAIN}/compras`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Lista de compras', url: `${_path.ROOTMAIN}/compras` },
            { title: 'Proveedores', url: `${_path.ROOTMAIN}/proveedores` },
            { title: 'Cuentas por pagar', url: `${_path.ROOTMAIN}/compras/reportes/cxp` },
            {
                title: 'Reportes',
                url: ``,
                submenu: [
                    { title: 'Compras de productos', url: `${_path.ROOTMAIN}/compras/reportes/` },
                ]
            }
        ],
    },
}, {
    layout: 'app',
    title: 'Entradas',
    url: `${_path.ROOTMAIN}/movimientos/entradas`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Ajuste', url: `${_path.ROOTMAIN}/movimientos/entradas` },
            { title: 'Inventario Inicial', url: `${_path.ROOTMAIN}/movimientos/inv-inicial` },
            // { title: 'Solicitud de traslado', url: `${_path.ROOTMAIN}/movimientos/traslados` },    
        ],
    },
}, {
    layout: 'app',
    title: 'Salidas',
    url: `${_path.ROOTMAIN}/movimientos/salidas`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Ajustes de salida', url: `${_path.ROOTMAIN}/movimientos/salidas` },
            // { title: 'Despachos', url: `${_path.ROOTMAIN}/movimientos/despacho` },    
        ],
    },
}, {
    layout: 'app',
    title: 'Configuración',
    url: `${_path.ROOTMAIN}/usuarios`,
    submenu: {
        type: 'menu',
        menu: [
            { title: 'Usuarios', url: `${_path.ROOTMAIN}/usuarios` },
            { title: 'Roles', url: `${_path.ROOTMAIN}/roles` },
            { title: 'Recursos', url: `${_path.ROOTMAIN}/permisos` },
            { title: 'Bodegas', url: `${_path.ROOTMAIN}/areas` },
            { title: 'Bancos', url: `${_path.ROOTMAIN}/bancos` },
            { title: 'Justificación de Notas Crédito', url: `${_path.ROOTMAIN}/gruponotacredito` },
            // { title: 'Autorizaciones', url: `${_path.ROOTMAIN}/authorizations` },   
            // { title: 'Comisión por Categoria', url: `${_path.ROOTMAIN}/comission-config` },   
            // { title: 'Metas', url: `${_path.ROOTMAIN}/goals` },   
            // { title: 'Categoria de Gastos', url: `${_path.ROOTMAIN}/cateroria-gastos` },   
            // { title: 'Gastos', url: `${_path.ROOTMAIN}/gastos` },
            // { title: 'Estado de Resultados', url: `${_path.ROOTMAIN}/EstadoResultados` },
        ],
    },
}];


export default menu;